import { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary fanget feil:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-slate-50 p-4">
          <div className="card max-w-lg p-6">
            <h1 className="mb-2 text-lg font-semibold text-red-700">
              Noe gikk galt i brukergrensesnittet
            </h1>
            <p className="mb-4 text-sm text-slate-600">
              En uventet feil oppstod. Prøv å laste siden på nytt.
            </p>
            <pre className="mb-4 max-h-48 overflow-auto rounded-lg bg-slate-100 p-3 text-xs text-slate-700">
              {this.state.error?.message}
              {'\n'}
              {this.state.error?.stack}
            </pre>
            <div className="flex gap-2">
              <button
                onClick={() => {
                  this.setState({ hasError: false, error: null });
                  window.location.reload();
                }}
                className="btn-primary"
              >
                Last på nytt
              </button>
              <button
                onClick={() => {
                  if ('caches' in window) {
                    caches.keys().then((names) => {
                      names.forEach((name) => caches.delete(name));
                    });
                  }
                  if ('serviceWorker' in navigator) {
                    navigator.serviceWorker.getRegistrations().then((regs) => {
                      regs.forEach((reg) => reg.unregister());
                    });
                  }
                  window.location.reload();
                }}
                className="btn-secondary"
              >
                Tøm cache og last på nytt
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.state.hasError ? null : this.props.children;
  }
}
